/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileReportParameters } from '../../models/profile-report-parameters';
import { ProfileReportResponse } from '../../models/profile-report-response';

export interface ProfileReportMarketDownload$Params {

/**
 * ID of profile
 */
  id: number;

/**
 * Type of averages (see more type ProfileReportAveragesType)
 */
  type: string;
  from: number;
  to: number;
      body: ProfileReportParameters
}

export function profileReportMarketDownload(http: HttpClient, rootUrl: string, params: ProfileReportMarketDownload$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileReportResponse>> {
  const rb = new RequestBuilder(rootUrl, profileReportMarketDownload.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('type', params.type, {});
    rb.path('from', params.from, {});
    rb.path('to', params.to, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileReportResponse>;
    })
  );
}

profileReportMarketDownload.PATH = '/rest/profile/{id}/report/market/{type}/{from}/{to}';
